import { atom } from "jotai";
import { DataForCreate } from "../utils/types/AtomsTypes";

export const dataForCreate = atom<DataForCreate>();
export const modalStateAtom = atom(false);
export const inventoryStatusAtom = atom('Realizado Parcialmente');
export const inventoryIdAtom = atom<number | null>(null);